<template>
  <div class="row justify-center models__wrapper">
    <LocationPopup v-if="userData"></LocationPopup>

    <!--<pre>{{filter}}</pre>-->
    <!-- Main -->
    <div id="models-main" class="models_main">
      <!-- лоадер -->
      <!-- <preloader v-if="loading"></preloader> -->

      <div class="container" :class="{'container--skeleton': !contentLoaded}">
        <div class="row justify-center posr">
          <div
            class="col-xxl-8 col-lg-9 col-12 models-block"
            key="models"
            v-show="true"
          >
            <div v-if="!contentLoaded" class="models_main-total--skeleton bg-skeleton"></div>
            <bim-text-h4 v-else bold class="models_main-total text-center mb-6">
              <span class="models_main-total--first-row">В библиотеке</span>
              <span class="models_main-total--second-row">{{ totalAllModels | discharge }} {{ totalAllModels | declOfNum(['модель', 'модели', 'моделей'], true) }}</span>
            </bim-text-h4>

            <!--Скелет с кнопками-->
            <div v-if="!contentLoaded" class="models-buttons-wrap models-buttons-wrap--skeleton bg-skeleton"></div>
            <!--Кнопки и сортировка-->
            <div v-else class="models-buttons-wrap justify-start justify-lg-center align-center">
              <!-- Кнопка фильтра -->
              <bim-button
                @click="switchFilter()"
                color="white"
                size="s"
                square
                width="32"
                height="32"
                class="filter_btn mr-auto d-lg-none"
                v-if="!loading"
              >
                <span :class="filtershow ? 'filter_btn-inner--active' : 'filter_btn-inner'">
                  <svg class="d-flex justify-center align-center">
                    <use href="/dist/assets/front_white/img/svg/settings.svg#settings"></use>
                  </svg>
                </span>
              </bim-button>

              <a href="/manufacturers/?from=library" target="_blank" class="models-button mr-lg-9 mr-6 d-none d-lg-flex">каталог производителей</a>
              <a
                href="/bim/?from=library"
                target="_blank"
                class="models-button mr-lg-9 mr-6"
              >{{$windowWidth >= 960 ? 'Разработать BIM-модель' : 'Разработать модель'}}
              </a>
              <a href="/ar/?from=library" target="_blank" class="models-button mr-lg-9 mr-6 d-none d-lg-flex">Разработать AR-модель</a>
              <div @click="requestModelOpen = true" class="models-button d-none d-lg-flex">Запросить модель</div>
            </div>

            <div class="models-slider mb-6 row">
              <div class="col-12">
                <!-- Производители -->
                <VipsLogoSwiper
                  v-if="contentLoaded"
                  :vips="randomVipList"
                />
                <div v-else class="d-md-flex d-none overflow-h">
                  <div v-for="n in 12" :key="n" class="manufacturers-slide manufacturers-slide--margin bg-skeleton" style="flex-shrink: 0;"></div>
                </div>
              </div>
            </div>

            <!--Поиск-->
            <searchModel
              :showSearchHints="false"
              :placeholder="this.$t('Поиск по библиотеке')"></searchModel>

            <div v-if="contentLoaded && Object.keys(filterTags).length" class="filter-tags-wrap">
              <span class="filter-tags" v-for="(value, key) of filterTags" :key="key">{{value}} <i @click="resetFilter(key)" class="icon-tag_close"></i></span>
            </div>

            <models
              :class="filtershow ? 'd-lg-block d-none' : 'd-block'"
              @openFilter="switchFilter(true)"
            />
          </div>

          <div
            class="col-xl-2 col-lg-3 col-12 filter__wrapper"
            v-show="filtershow"
            key="filter"
          >
            <filterModel v-show="contentLoaded" @closeFilter="filtershow = false"/>
            <div
              class="filter-skeleton bg-skeleton"
              v-if="!contentLoaded"
            >
            </div>
          </div>
        </div>

        <AdfoxLongWide class="my-9" />
      </div>
    </div>

    <secretModal  v-if="secretModalOpen" @closeSecretModal="secretModalOpen = false"/>
    <embedModelsModal/>
    <requestModel
      v-model="requestModelOpen"
    ></requestModel>
  </div>
</template>

<script>
import { shuffle } from 'lodash'

import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// Поиск моделей
import searchModel from './SearchModels.vue'
// Фильтр
import filterModel from './Filter.vue'
// Отрисовка списка моделей
import models from './Models.vue'
// import { setTimeout } from "timers";
import secretModal from './SecretModal'
import embedModelsModal from './EmbedModelsModal'
// модалка с формой на запрос модели
import requestModel from '../../components/popups/RequestModel'

import bimButton from '@bimlib/components/bimButton'
import bimPopup from '@bimlib/components/bimPopup'
import bimTextH4 from '@bimlib/components/bimTextH4'
import bimTextDesc from '@bimlib/components/bimTextDesc'
import { mapActions, mapGetters } from 'vuex'

import VipsLogoSwiper from '@/components/vips-logo-swiper'
import AdfoxLongWide from '@/components/banners/adfox-long-wide'
import LocationPopup from "@/pages/modals/location-popup.vue";

export default {
  components: {
    LocationPopup,
    searchModel,
    filterModel,
    models,
    Swiper,
    SwiperSlide,
    secretModal,
    requestModel,
    bimButton,
    bimPopup,
    bimTextH4,
    bimTextDesc,
    embedModelsModal,
    VipsLogoSwiper,
    AdfoxLongWide
  },
  data () {
    return {
      secretModalOpen: false,
      filtershow: true,
      manufacturers: [],
      requestModelOpen: false,
      vipList: [],
    }
  },
  created () {
    this.getVipList()
    this.filtershow = this.$windowWidth > 960
  },
  computed: {
    ...mapGetters([
      'getLocationQuery',
      'totalModels',
      'totalAllModels',
      'filter',
    ]),
    randomVipList() {
      return shuffle(this.vipList)
    },
    filterTags () {
      const params = new Map(this.getLocationQuery.entries())
      const obj = {};
      [...params].forEach(el => {
        switch (el[0]) {
          case 'manufacturers':
            obj[el[0]] = 'Производители'
            break
          case 'files':
            obj[el[0]] = 'Типы файлов'
            break
          case 'category':
          case 'type':
          case 'class':
            obj.category = 'Разделы'
            break
          case 'objects':
            obj[el[0]] = 'Типы объектов'
            break
          case 'aparts':
            obj[el[0]] = 'Помещения'
            break
          case 'materials':
            obj[el[0]] = 'Материалы'
            break
          case 'length':
          case 'width':
          case 'height':
          case 'weight':
          case 'diametr':
            obj.sizes = 'Размеры'
            break
          case 'view3d':
          case 'viewAr':
            obj.preview = 'Предпросмотр'
        }
      })
      this.counterFilterTags(Object.keys(obj).length)
      return obj
    },
    loading () {
      return this.$store.getters.getLoading
    },
    contentLoaded () {
      return this.$store.getters.contentLoaded
    },
    userData(){
      return this.$store.state.user.user || null
    }
  },
  methods: {
    ...mapActions([
      'getUserData',
      'resetFilter',
      'counterFilterTags',
    ]),

    openSecretModal () {
      document.addEventListener('keydown', e => {
        if (e.ctrlKey && e.code === 'KeyQ') {
          this.secretModalOpen = !this.secretModalOpen
        }
      })
      // document.addEventListener("keydown", e => {
      //   if (e.code === "Escape") {
      //     this.secretModalOpen = false;
      //   }
      // });
    },
    switchFilter (val) {
      this.$forceUpdate()
      val ? (this.filtershow = val) : (this.filtershow = !this.filtershow)
    },
    async getVipList () {
      this.vipList = await this.$store.dispatch('getVipList')
    },
  },
  mounted() {
    this.getUserData()
    this.openSecretModal()
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.container--skeleton {
  width : 1479px;

  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-lg)) {
    width : unset;
  }
}

.bg-skeleton {
  // background-image: linear-gradient(
  //   110deg,
  //   #ececed 73%,
  //   #e9e9eaab 75%,
  //   #ececed 77%,
  //   #ececed 78%,
  //   #e9e9eaab 84%,
  //   #e9e9eaab 88%,
  //   #ececed 94%,
  //   #ececed 100%
  // );
  animation-duration        : 1s;
  animation-fill-mode       : forwards;
  animation-iteration-count : infinite;
  animation-name            : skeletonShimmer;
  animation-timing-function : cubic-bezier(.17, .67, .83, .67);
  background                : linear-gradient(to right, #f4f4f4 0%, #e3e3e3 50%, #f4f4f4 100%);
  background-size           : 200% 100%;
  // animation: 1.8s ease-in-out loading infinite;
}

@keyframes skeletonShimmer {
  0% {
    background-position : 100% 0
  }
  100% {
    background-position : -100% 0
  }
}

.filter__wrapper {
  /*overflow : hidden;*/
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-lg)) {
    border-top : 1px solid $border-light;
  }
}

.filter-skeleton {
  width         : 100%;
  height        : 100%;
  border-radius : 3px;
}

.filter_btn {
  overflow : hidden;

  .filter_btn-inner {
    display          : flex;
    align-items      : center;
    justify-content  : center;
    width            : 32px;
    height           : 32px;
    background-color : $white-color;

    svg {
      width      : 16px;
      height     : 16px;
      fill       : $black-color;
      transition : fill 0s;
    }

    &--active {
      @extend .filter_btn-inner;
      background-color : $primary-color !important;

      svg {
        fill : $white-color;
      }
    }
  }


}

.models__wrapper {
  background-color : #fafafa;
}

.models_main-total {
  @media (min-width : $breakpoint-xs) and (max-width : $breakpoint-lg) {
    text-align : left;
    &--first-row {
      display       : flex;
      font-size     : 14px;
      opacity       : .75;
      margin-bottom : 7px;
    }
    &--second-row {
      font-size : 24px;
      display   : flex;
    }
  }

  &--skeleton {
    width         : 70%;
    height        : 47px;
    border-radius : 3px;
    margin        : 0 auto;
    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-lg)) {
      margin : 0;
      width  : 50%;
      height : 49.4px;
    }
  }
}

.models_main {
  width: 100%;
  padding-top : 50px;

  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-lg)) {
    padding-top : 32px;
  }
}

.models_main-total-num {
  margin-top  : 10px;
  font-size   : 42px;
  font-weight : bold;
  color       : #4d4d4d;

  @media (min-width : $breakpoint-xs) and (max-width : $breakpoint-lg) {
    font-size : 32px;
  }

  &--skeleton {
    margin-top    : -6px;
    width         : 300px;
    height        : 48px;
    border-radius : 3px;
  }
}

.models-buttons-wrap {
  display       : flex;
  margin-bottom : 24px;
  width         : 100%;
  transition    : 0s;

  @media (min-width : $breakpoint-xs) and (max-width : $breakpoint-lg) {
    margin-bottom : 14px;
  }

  &--skeleton {
    width         : 85%;
    height        : 22px;
    border-radius : 3px;
    margin        : 24px auto;
    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-lg)) {
      width         : 100%;
      height        : 32px;
      margin-bottom : 14px;
    }
  }

  .models-button {
    display        : flex;
    cursor         : pointer;
    text-transform : uppercase;
    @include font-main(12px, bold, 1.83, .5px);

    @media (min-width : $breakpoint-xs) and (max-width : $breakpoint-lg) {
      display        : inline-flex;
      font-weight    : normal;
      text-transform : unset;
      white-space    : nowrap;
      border-bottom  : 1px dashed $primary-color;
    }

    &:hover {
      color : $primary-color;
    }
  }
}

/*.models-buttons-wrap_inner {
  display     : flex;
  align-items : flex-end;
  @media (min-width : $breakpoint-xs) and (max-width : $breakpoint-md) {
    display : none;
  }
  @media (min-width : $breakpoint-lg) and (max-width : $breakpoint-xl) {
    margin : 14px 0;
  }
}*/

.manufacturers-block {
  flex-wrap: wrap;
}

.swiper-container {
  width      : 100%;
  height     : 74px !important;
  margin     : 0;
  margin-top : -10px !important;
}

.manufacturers-slide {
  display    : inline-block;
  box-sizing : border-box;
  max-width  : 116px;
  min-width  : 70px;
  height     : 66px;
  padding    : 8px;
  opacity    : 0.75;
  transition : 0.2s;

  &--margin {
    margin-right : 14px;
    @media (min-width : $breakpoint-lg) and (max-width : $breakpoint-xxl) {
      margin-right : 16px;
    }
  }

  .manufacturers-link {
    display         : flex;
    justify-content : center;
    align-items     : center;
    height          : 100%;
  }

  img {
    max-width  : 100%;
    height     : 100%;

    object-fit : contain;
  }

  &:hover {
    opacity : 1;
  }
}

.opacity-enter-active,
.opacity-leave-active {
  transition : opacity 0.5s;
}

.opacity-enter,
.opacity-leave-to {
  transform : unset !important;
  opacity   : 0;
}

.opacity-leave-to {
  opacity : 0;
}

.opacity-leave-active {
  // .opacity-enter, .opacity-enter-active, .opacity-leave-active {
  // position: absolute;
  left : 0;
}

.bounce-enter-active {
  animation : bounce-in 0.3s;
}

.bounce-leave-active {
  animation : bounce-in 0.3s reverse;
}

@keyframes bounce-in {
  0% {
    transform : scale(0);
  }
  50% {
    transform : scale(1.1);
  }
  100% {
    transform : scale(1);
  }
}

/*.bold {*/
/*  font-weight : bold;*/
/*  font-size   : 25px;*/
/*}*/

.transition {
  transition : all 0.3s ease-in;
}

.filter-tags-wrap {
  display       : flex;
  flex-wrap     : wrap;
  align-items   : center;
  margin-bottom : 24px;
}

.filter-tags {
  font-size     : 14px;
  margin-bottom : 6px;
  margin-right  : 14px;
  display       : flex;
  align-items   : center;

  i {
    cursor      : pointer;
    margin-left : 6px;
    font-size   : 16px;

    &:hover {
      opacity : 0.85;
    }
  }
}
</style>
